export function unveilImages(self, threshold, callback) {
    let $w = $(window);
    let th = threshold || 0;
    let retina = window.devicePixelRatio > 1;
    let attrib = retina ? 'data-src-retina' : 'data-src';
    let images = self;
    let loaded;

    self.one('unveil', function onUnveil() {
        let source = this.getAttribute(attrib);

        source = source || this.getAttribute('data-src');
        if (source) {
            this.setAttribute('src', source);
            if (typeof callback === 'function') {
                callback.call(this);
            }
        }
    });

    function unveil() {
        let inview = images.filter(function imageIsInView() {
            let $e = $(this);
            let wt = $w.scrollTop();
            let wb = wt + $w.height();
            let et = $e.offset().top;
            let eb = et + $e.height();

            return eb >= wt - th && et <= wb + th;
        });

        loaded = inview.trigger('unveil');
        images = images.not(loaded);
    }

    $w.on('scroll', unveil);

    unveil();

    return this;
}
